import { TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'
import { StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

/** 软件禁用策略中的目标进程行 */
export interface SoftwareDisabledProcessInfo {
  name: string
  path: string
  md5: string
  signature: string
}

export interface StrategySettings {
  /** 总开关 */
  main_switch: boolean
  handle_type: number
  interval_type: number
  frequency: number
  software_ids: number[]
  /** 目标进程（与目标软件并列配置） */
  process_infos?: SoftwareDisabledProcessInfo[]
  regular_tasks?: TaskTimeSetting[]
  /** 策略应用场景：install=禁止安装 run=禁止运行 update=禁止升级 */
  scenes?: string[]
}

export interface StrategyListData extends StrategyListDataCommon {
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略 */
  strategy: StrategySettings
}

/** 统计请求参数 */
export interface OverviewStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
}

/** 统计响应数据 */
export interface OverviewStatResponseData {
  /** 受控软件数量（生效的策略中，目标软件的数量，需去重） */
  controlled_software_count?: number
  /** 拦截次数（近30天） */
  interception_count_30days?: number
  /** 生效策略数量 */
  active_policy_count?: number
  /** 涉及终端数量 */
  involved_terminal_count?: number
}

/** 排行请求参数 */
export interface RankingRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 排行项 */
export interface RankingItem {
  /** 软件名称 */
  soft_name: string
  /** 软件类型 */
  soft_type?: string
  /** 拦截次数 */
  count: number
}

/** 排行响应数据 */
export interface RankingResponseData {
  /** 排行列表 */
  list: RankingItem[]
}

/** 分布请求参数 */
export interface DistributionRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

/** 分布项 */
export interface DistributionItem {
  /** 分组名称 */
  group_name: string
  /** 拦截次数 */
  count: number
  /** 占比（百分比） */
  percentage?: number
}

/** 分布响应数据 */
export interface DistributionResponseData {
  /** 分布列表 */
  list: DistributionItem[]
}
export interface softDisableGroupRequestParams {
  /** 开始时间 */
  start_time: string
  /** 结束时间 */
  end_time: string
}

export interface softDisableGroupList {
  /** 分组名称 */
  name: string
  /** 分组占比 */
  percentage: number
  /** 终端分组 id（可从分布图带入选中分组） */
  group_id: number
}
export interface softDisableStatList {
  /** 分组id */
  group_id: number
  /** 分组名(软件类型|部门) */
  group_name: string
  /** 该类型软件使用数量 */
  Count: number
}
export interface softDisableGroupResponseData {
  list?: softDisableGroupList[]
}
export interface softDisableStatResponseData {
 /** 受控软件数量（生效策略中去重后的软件总数） */
  controlled_soft_count: number
  /** 生效策略数量（当前状态为已启用的软件禁用策略数量） */
  enable_count?: number
  /** 涉及终端数量（当前状态为已启用的策略应用到的终端数量） */
  terminal_count?: number
  /** 拦截次数（软件禁用日志中，已拦截的软件的次数） */
  total?: number
}
export interface softDisableTopRequestParams {
  /** 开始时间 */
  start_time: string
  /** 结束时间 */
  end_time: string
}

export interface softDisableTopList {
  /** 软件名称 */
  name: string
  /** 拦截次数 */
  count: number
  // 分组
}

export interface softDisableTopResponseData {
  list?: softDisableTopList[]
}
@Injectable()
export class SoftwareDisabledService {
  constructor(private http: Http) {}
 getSoftmgrSoftDisableTop (data: softDisableTopRequestParams) {
    return this.http.post<softDisableTopResponseData>('/softmgr/soft-disable-top', data)
  }
  getSoftmgrSoftDisableGroup (data: softDisableGroupRequestParams) {
    return this.http.post<softDisableGroupResponseData>('/softmgr/soft-disable-group', data)
  }
  getSoftmgrSoftDisableStat() {
    return this.http.post<softDisableStatResponseData>('/softmgr/soft-disable-stat', {})
  }
}
